import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  color: ${({ theme }) => theme.colors.WhiteGray};
  font-weight: 500;
`;
